import React, {ReactElement, useState} from 'react';
import GreenIcon from '../../assets/images/green_icon.svg';
import {ItemListType, OrderResponse} from '../../lib/order-types';
import moment from 'moment';
import {getMetadata, getUser} from '../../core/localstorage-data';
import {lmrCheckedData} from '../../redux/orderSlice';
import {useAppSelector} from '../../redux/hooks';

type CardProps = {
  type: string;
  onCardClick: (type: string) => void;
  order: OrderResponse;
  activeOrder: string;
};

const Card: React.FC<CardProps> = ({
  type,
  onCardClick,
  order,
  activeOrder,
}: CardProps): ReactElement => {
  let BAG_PRICE = 0;
  const metaData = getMetadata();
  const customerProfileData = getUser();
  const bagMetaData = metaData.find(
    (obj: {name: string}) => obj.name === 'bag-price',
  );
  if (bagMetaData) {
    BAG_PRICE = bagMetaData.value;
  }
  const lmrChecked = useAppSelector(lmrCheckedData);
  function handleClick(type: string) {
    onCardClick(type);
  }
  let totalMRP = 0;
  let promoDiscountAmount = 0;
  let bagPrice = 0;
  order &&
    order.itemList &&
    order.itemList.forEach(item => {
      totalMRP += item.sellPrice;
      promoDiscountAmount += item.promoDiscountAmount;
    });
  if (order && order.carryBagItem) {
    bagPrice = BAG_PRICE * order.carryBagItem.quantity;
  }
  let couponDiscount = 0;
  order &&
    order.itemList &&
    order.itemList.forEach(item => {
      if (item.couponDiscountAmount) {
        couponDiscount += item.couponDiscountAmount;
      }
    });
  let lmrRewardsPrice = 0;
  if (lmrChecked) {
    lmrRewardsPrice = customerProfileData.pointsAvailable;
  } else {
    lmrRewardsPrice = 0;
  }

  let totalAmount =
    order && order.itemList
      ? order.itemList.reduce((prevAmount, item) => {
          return prevAmount + item.extSellPrice;
        }, 0)
      : 0;
  totalAmount = totalAmount + bagPrice - lmrRewardsPrice;
  console.log(order);
  return (
    <div
      className={`rounded-2xl mb-4 border p-4 border-solid  ${
        order.orderId === activeOrder
          ? 'border-royal_blue bg-blue_four'
          : 'border-gray-400'
      }`}
      onClick={() => handleClick(type, order)}>
      <div className="top flex justify-between">
        <div className="left font-roboto font-medium">
          Order ID #{order.orderId}
        </div>
        <div className="right flex items-center">
          {type === 'completed' && (
            <img src={GreenIcon} width="30" height="30" />
          )}
          <div className="font-roboto text-xxs">
            {moment(order.createdAt).format('DD MMM YYYY')}
          </div>
        </div>
      </div>
      {order.isCompleted === true &&
        order.hasDetagged === false &&
        order.isFailed === true && (
          <div className="text-xs bg-red-600 px-1.5 rounded leading-4 capitalize w-max text-white">
            Failed
          </div>
        )}
      {order.paymentInitiated === true &&
        order.isCompleted === false &&
        order.isFailed === false && (
          <div className="text-xs bg-gray-700 px-1.5 rounded leading-4 capitalize w-max text-white">
            pending
          </div>
        )}
      <div className="bottom mt-6">
        <div className="flex justify-between">
          <div className="flex flex-col">
            <div className="font-roboto text-xxs text-black text-opacity-50">
              Items
            </div>
            <div>{order.itemList?.length}</div>
          </div>
          <div className="border-0.5 border-gray-300 h-9"></div>
          <div className="flex flex-col text-center">
            <div className="font-roboto text-xxs text-black text-opacity-50">
              Total MRP
            </div>
            <div>
              {'\u20B9'} {totalMRP.toFixed(2)}
            </div>
          </div>
          <div className="border-0.5 border-gray-300 h-9"></div>
          <div className="flex flex-col text-right">
            <div className="font-roboto text-xxs text-black text-opacity-50">
              Net paid Amount
            </div>
            <div>
              {'\u20B9'} {totalAmount.toFixed(2)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
